import React, { useEffect } from "react";
import {
  makeStyles,
  Box,
  Grid,
  MenuItem,
  TextField as TextField2,
} from "@material-ui/core";
import { Field, Form, Formik, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import { useHistory, useLocation } from "react-router-dom";
import { walletBalanceAgentDispatch } from "../reducers/UserReducer";
import {
  FlightFareQuoteEtravDispatch,
  FlightFareQuoteDispatch,
  FlightAddBookingDispatch,
  FlightSSRTBODispatch,
  FlightSSREtravDispatch,
} from "../reducers/HomeReducer";
import { useDispatch, useSelector } from "react-redux";
import { FlightFareQuoteTripJackDispatch } from "../reducers/TripjackReducer";
import {
  setBaggage,
  setMealInfo,
  setBaggageAdult1,
  setBaggageAdult2,
  setBaggageAdult3,
  setBaggageAdult4,
  setBaggageAdult5,
  setBaggageAdult6,
  setBaggageAdult7,
  setBaggageAdult8,
  setBaggageAdult9,
  setBaggageChild1,
  setBaggageChild2,
  setBaggageChild3,
  setBaggageChild4,
  setBaggageChild5,
  setBaggageChild6,
  setMealAdult1,
  setMealAdult2,
  setMealAdult3,
  setMealAdult4,
  setMealAdult5,
  setMealAdult6,
  setMealAdult7,
  setMealAdult8,
  setMealAdult9,
  setMealChild1,
  setMealChild2,
  setMealChild3,
  setMealChild4,
  setMealChild5,
  setMealChild6,
} from "../reducers/UiReducer";
const title = ["Mr", "Mrs", "Ms", "Mstr", "Miss"];
const titleC = ["Mstr", "Miss"];
const titleI = ["Mr", "Ms", "Mstr", "Miss"];
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    // backgroundColor: 'white',
    marginBottom: 30,
    width: "100%",
    marginTop: 10,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: 5,
    },
  },
  InputPropsStyle: {
    // backgroundColor: 'white',
    borderRadius: 15,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "rgb(239, 51, 57)",
    color: "white",
    borderRadius: 12,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "rgb(239, 51, 57)",
    },
  },
  tabBorder: {
    borderBottom: "2px solid transparent",
    color: "#7B95AB",
    fontWeight: 400,
  },
  tabBorderColor: {
    borderBottom: "2px solid #313131",
    color: "#00325B",
    fontWeight: 700,
  },
  tab: {
    [theme.breakpoints.up("sm")]: {
      "& .MuiTab-root": {
        minWidth: 241,
        fontSize: 22,
      },
    },
  },
  date: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      width: "100%",
    },
  },
  dob: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  passport: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 12,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
    // '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
    // 	fontSize: 14,
    // },
  },
  root2: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& label": {
      fontSize: 15,
    },
  },
}));
const FlightSummaryForm = ({ time }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = React.useState(null);
  const [child1, setChild1] = React.useState(new Date());
  const [child2, setChild2] = React.useState(new Date());
  const [child3, setChild3] = React.useState(new Date());
  const [child4, setChild4] = React.useState(new Date());
  const [child5, setChild5] = React.useState(new Date());
  const [child6, setChild6] = React.useState(new Date());
  const [infant1, setInfant1] = React.useState(new Date());
  const [infant2, setInfant2] = React.useState(new Date());
  const [infant3, setInfant3] = React.useState(new Date());
  const [infant4, setInfant4] = React.useState(new Date());
  const [infant5, setInfant5] = React.useState(new Date());
  const [infant6, setInfant6] = React.useState(new Date());
  const {
    etravflightFare,
    selectedOrigin,
    selectedDepart,
    baggageAdult1,
    baggageAdult2,
    baggageAdult3,
    baggageAdult4,
    baggageAdult5,
    baggageAdult6,
    baggageAdult7,
    baggageAdult8,
    baggageAdult9,
    baggageChild1,
    baggageChild2,
    baggageChild3,
    baggageChild4,
    baggageChild5,
    baggageChild6,

    mealAdult1,
    mealAdult2,
    mealAdult3,
    mealAdult4,
    mealAdult5,
    mealAdult6,
    mealAdult7,
    mealAdult8,
    mealAdult9,
    mealChild1,
    mealChild2,
    mealChild3,
    mealChild4,
    mealChild5,
    mealChild6,
    curr
  } = useSelector((state) => state.ui);
  const { farequotetripjack } = useSelector((state) => state.tripjack);
  const { agentlogin } = useSelector((state) => state.user);
  const { ssrTBO,currency } = useSelector((state) => state.home);
  function calculate_age(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);

    // return Math.abs(age_dt.getUTCFullYear() - 1970);
    let age = Math.abs(age_dt.getUTCFullYear() - 1970);
    if (age < 6) {
      alert("Please Select Valid Age");
    } else if (age > 12) {
      alert("Please Select Valid Age");
    }
    console.log("Hen", Math.abs(age_dt.getUTCFullYear() - 1970));
  }
  const Convert = Number(curr==='INR'?currency.conversion_rates.INR:curr==='USD'?currency.conversion_rates.USD:curr==='AFN'?currency.conversion_rates.AFN:1)
  const dispatch = useDispatch();
  useEffect(() => {
    if (location.state.OneflightData) {
      if (location.state.OneflightData.Airline_Code) {
        let formEtravFare = {
          Search_Key: location.state.IDEtrav,
          AirRepriceRequests: [
            {
              Flight_Key: location.state.OneflightData.Flight_Key,
              Fare_Id: location.state.OneflightData.Fares.Fare_Id,
            },
          ],
          // Customer_Mobile: data.phone,
          GST_Input: false,
          SinglePricing: true,
          agent_id:
            agentlogin && agentlogin.status === 200
              ? agentlogin.result.result.id
              : 0,
        };

        dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
        dispatch(FlightSSREtravDispatch(formEtravFare));
        dispatch(
          walletBalanceAgentDispatch(
            agentlogin &&
              agentlogin.result &&
              agentlogin.result.result &&
              agentlogin.result.result.email,
            agentlogin &&
              agentlogin.result &&
              agentlogin.result.result &&
              agentlogin.result.result.id
          )
        );
      } else if (location.state.OneflightData.AirlineCode) {
        let formData1 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.OneflightData.ResultIndex,
          agent_id:
            agentlogin && agentlogin.status === 200
              ? agentlogin.result.result.id
              : 0,
        };
        let ssr = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.OneflightData.ResultIndex,
        };

        dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
      } else if (location.state.OneflightData.Supplier === "TJK") {
        let formData = {
          priceIds: [location.state.OneflightData.totalPriceList.id],
        };
        dispatch(FlightFareQuoteTripJackDispatch(formData));
        console.log("TJK");
      }
    } else if (location.state.selectedonward) {
      if (
        location.state.selectedonward[0]?.Airline_Code &&
        location.state.selectedReturn[0]?.Airline_Code
      ) {
        let formEtravFare = {
          Search_Key: location.state.IDEtrav,
          AirRepriceRequests: [
            {
              Flight_Key: location.state.selectedonward[0]?.Flight_Key,
              Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
            },
            {
              Flight_Key: location.state.selectedReturn[0]?.Flight_Key,
              Fare_Id: location.state.selectedReturn[0]?.Fares.Fare_Id,
            },
          ],
          // Customer_Mobile: data.phone,
          GST_Input: false,
          SinglePricing: true,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };

        dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
      } else if (
        location.state.selectedonward[0]?.Airline_Code &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        if (location.state.selectedonward[0]?.Airline_Code) {
          let formEtravFare = {
            Search_Key: location.state.IDEtrav,
            AirRepriceRequests: [
              {
                Flight_Key: location.state.selectedonward[0]?.Flight_Key,
                Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
              },
            ],
            // Customer_Mobile: data.phone,
            GST_Input: false,
            SinglePricing: true,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
        }
        if (location.state.selectedReturn[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
      } else if (
        location.state.selectedReturn[0]?.Airline_Code &&
        location.state.selectedonward[0]?.AirlineCode
      ) {
        if (location.state.selectedReturn[0].Airline_Code) {
          let formEtravFare = {
            Search_Key: location.state.IDEtrav,
            AirRepriceRequests: [
              {
                Flight_Key: location.state.selectedReturn[0].Flight_Key,
                Fare_Id: location.state.selectedReturn[0].Fares.Fare_Id,
              },
            ],
            // Customer_Mobile: data.phone,
            GST_Input: false,
            SinglePricing: true,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
        }
        if (location.state.selectedonward[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedonward[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
      } else if (
        location.state.selectedonward[0]?.AirlineCode &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        let formData1 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.selectedonward[0].ResultIndex,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };
        let formData2 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.selectedReturn[0].ResultIndex,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };

        dispatch(FlightFareQuoteDispatch(formData1));
        dispatch(FlightFareQuoteDispatch(formData2));
      } else if (
        location.state.selectedonward[0]?.Supplier === "TJK" &&
        location.state.selectedReturn[0]?.Supplier === "TJK"
      ) {
        let formData = {
          priceIds: [
            location.state.selectedonward[0].totalPriceList.id,
            location.state.selectedReturn[0].totalPriceList.id,
          ],
        };
        dispatch(FlightFareQuoteTripJackDispatch(formData));
      } else if (
        location.state.selectedonward[0]?.Supplier === "TJK" &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        if (location.state.selectedonward[0]?.Supplier === "TJK") {
          let formData = {
            priceIds: [location.state.selectedonward[0].totalPriceList.id],
          };
          dispatch(FlightFareQuoteTripJackDispatch(formData));
        }
        if (location.state.selectedReturn[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
      }
    } else if (location.state.intFlight) {
      let formData1 = {
        TraceId: location.state.IDTBO,
        ResultIndex: location.state.intFlight.ResultIndex,
        agent_id:
          agentlogin && agentlogin.status === 200
            ? agentlogin.result.result.id
            : 0,
      };
      let ssr = {
        TraceId: location.state.IDTBO,
        ResultIndex: location.state.intFlight.ResultIndex,
      };

      dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
    }
  }, [dispatch]);

  const convert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  };
  const handleFormSubmit = (data) => {
    if (location.state.OneflightData) {
      if (location.state.OneflightData.Airline_Code) {
        let formEtravFare = {
          Search_Key: location.state.IDEtrav,
          AirRepriceRequests: [
            {
              Flight_Key: location.state.OneflightData.Flight_Key,
              Fare_Id: location.state.OneflightData.Fares.Fare_Id,
            },
          ],
          Customer_Mobile: data.phone,
          GST_Input: false,
          SinglePricing: true,
          agent_id:
            agentlogin && agentlogin.status === 200
              ? agentlogin.result.result.id
              : 0,
        };

        dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
        dispatch(
          walletBalanceAgentDispatch(
            agentlogin &&
              agentlogin.result &&
              agentlogin.result.result &&
              agentlogin.result.result.email,
            agentlogin &&
              agentlogin.result &&
              agentlogin.result.result &&
              agentlogin.result.result.id
          )
        );
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            body: location.state.body,
            // BookingData: FormData,
            OneflightData: location.state.OneflightData,
            IDTBO: location.state.IDTBO,
            IDEtrav: location.state.IDEtrav,
            orderID: location.state.orderID,
          },
        });
      } else if (location.state.OneflightData.AirlineCode) {
        let formData1 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.OneflightData.ResultIndex,
          agent_id:
            agentlogin && agentlogin.status === 200
              ? agentlogin.result.result.id
              : 0,
        };
        let ssr = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.OneflightData.ResultIndex,
        };

        dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            // BookingData: FormData,
            body: location.state.body,
            OneflightData: location.state.OneflightData,
            IDTBO: location.state.IDTBO,
            IDEtrav: location.state.IDEtrav,
            orderID: location.state.orderID,
          },
        });
      } else if (location.state.OneflightData.Supplier === "TJK") {
        let formData = {
          priceIds: [location.state.OneflightData.totalPriceList.id],
        };
        dispatch(FlightFareQuoteTripJackDispatch(formData));
        console.log("TJK");
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            body: location.state.body,
            // BookingData: FormData,
            OneflightData: location.state.OneflightData,
            orderID: location.state.orderID,
          },
        });
      }
    } else if (location.state.selectedonward) {
      if (
        location.state.selectedonward[0]?.Airline_Code &&
        location.state.selectedReturn[0]?.Airline_Code
      ) {
        let formEtravFare = {
          Search_Key: location.state.IDEtrav,
          AirRepriceRequests: [
            {
              Flight_Key: location.state.selectedonward[0]?.Flight_Key,
              Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
            },
            {
              Flight_Key: location.state.selectedReturn[0]?.Flight_Key,
              Fare_Id: location.state.selectedReturn[0]?.Fares.Fare_Id,
            },
          ],
          Customer_Mobile: data.phone,
          GST_Input: false,
          SinglePricing: true,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };

        dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            orderID: location.state.orderID,
            returnBody: location.state.returnBody,
            IDTBO: location.state.IDTBO,
            IDEtrav: location.state.IDEtrav,
            //   BookingData: FormData,
            // orderID: location.state.orderID,
            selectedonward: location.state.selectedonward,
            selectedReturn: location.state.selectedReturn,
          },
        });
      } else if (
        location.state.selectedonward[0]?.Airline_Code &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        if (location.state.selectedonward[0]?.Airline_Code) {
          let formEtravFare = {
            Search_Key: location.state.IDEtrav,
            AirRepriceRequests: [
              {
                Flight_Key: location.state.selectedonward[0]?.Flight_Key,
                Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
              },
            ],
            Customer_Mobile: data.phone,
            GST_Input: false,
            SinglePricing: true,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
          history.push({
            pathname: "/confirmflight",
            state: {
              formData: data,
              orderID: location.state.orderID,
              returnBody: location.state.returnBody,
              IDTBO: location.state.IDTBO,
              IDEtrav: location.state.IDEtrav,
              // BookingData: FormData,
              // orderID: location.state.orderID,
              selectedonward: location.state.selectedonward,
              selectedReturn: location.state.selectedReturn,
            },
          });
        }
        if (location.state.selectedReturn[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
      } else if (
        location.state.selectedReturn[0]?.Airline_Code &&
        location.state.selectedonward[0]?.AirlineCode
      ) {
        if (location.state.selectedReturn[0].Airline_Code) {
          let formEtravFare = {
            Search_Key: location.state.IDEtrav,
            AirRepriceRequests: [
              {
                Flight_Key: location.state.selectedReturn[0].Flight_Key,
                Fare_Id: location.state.selectedReturn[0].Fares.Fare_Id,
              },
            ],
            Customer_Mobile: data.phone,
            GST_Input: false,
            SinglePricing: true,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
          history.push({
            pathname: "/confirmflight",
            state: {
              formData: data,
              orderID: location.state.orderID,
              returnBody: location.state.returnBody,
              IDTBO: location.state.IDTBO,
              IDEtrav: location.state.IDEtrav,
              // BookingData: FormData,
              // orderID: location.state.orderID,
              selectedonward: location.state.selectedonward,
              selectedReturn: location.state.selectedReturn,
            },
          });
        }
        if (location.state.selectedonward[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedonward[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
      } else if (
        location.state.selectedonward[0]?.AirlineCode &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        let formData1 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.selectedonward[0].ResultIndex,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };
        let formData2 = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.selectedReturn[0].ResultIndex,
          agent_id: agentlogin
            ? agentlogin.status === 200
              ? agentlogin?.result.result.id
              : 0
            : 0,
        };

        dispatch(FlightFareQuoteDispatch(formData1));
        dispatch(FlightFareQuoteDispatch(formData2));
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            orderID: location.state.orderID,
            returnBody: location.state.returnBody,
            IDTBO: location.state.IDTBO,
            IDEtrav: location.state.IDEtrav,
            selectedonward: location.state.selectedonward,
            selectedReturn: location.state.selectedReturn,
          },
        });
      } else if (
        location.state.selectedonward[0]?.Supplier === "TJK" &&
        location.state.selectedReturn[0]?.Supplier === "TJK"
      ) {
        let formData = {
          priceIds: [
            location.state.selectedonward[0].totalPriceList.id,
            location.state.selectedReturn[0].totalPriceList.id,
          ],
        };
        dispatch(FlightFareQuoteTripJackDispatch(formData));
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            orderID: location.state.orderID,
            returnBody: location.state.returnBody,
            //   IDTBO: location.state.IDTBO,
            //   IDEtrav: location.state.IDEtrav,
            // BookingData: FormData,
            // orderID: location.state.orderID,
            selectedonward: location.state.selectedonward,
            selectedReturn: location.state.selectedReturn,
          },
        });
      } else if (
        location.state.selectedonward[0]?.Supplier === "TJK" &&
        location.state.selectedReturn[0]?.AirlineCode
      ) {
        if (location.state.selectedonward[0]?.Supplier === "TJK") {
          let formData = {
            priceIds: [location.state.selectedonward[0].totalPriceList.id],
          };
          dispatch(FlightFareQuoteTripJackDispatch(formData));
        }
        if (location.state.selectedReturn[0]?.AirlineCode) {
          let formData1 = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            agent_id: agentlogin
              ? agentlogin.status === 200
                ? agentlogin?.result.result.id
                : 0
              : 0,
          };

          dispatch(FlightFareQuoteDispatch(formData1));
        }
        history.push({
          pathname: "/confirmflight",
          state: {
            formData: data,
            orderID: location.state.orderID,
            returnBody: location.state.returnBody,
            //   IDTBO: location.state.IDTBO,
            //   IDEtrav: location.state.IDEtrav,
            // BookingData: FormData,
            // orderID: location.state.orderID,
            selectedonward: location.state.selectedonward,
            selectedReturn: location.state.selectedReturn,
          },
        });
      }
    } else if (location.state.intFlight) {
      let formData1 = {
        TraceId: location.state.IDTBO,
        ResultIndex: location.state.intFlight.ResultIndex,
        agent_id:
          agentlogin && agentlogin.status === 200
            ? agentlogin.result.result.id
            : 0,
      };
      let ssr = {
        TraceId: location.state.IDTBO,
        ResultIndex: location.state.intFlight.ResultIndex,
      };

      dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
      history.push({
        pathname: "/confirmflight",
        state: {
          formData: data,
          // BookingData: FormData,
          body: location.state.body,
          returnBody: location.state.returnBody,
          intFlight: location.state.intFlight,
          IDTBO: location.state.IDTBO,
          IDEtrav: location.state.IDEtrav,
          orderID: location.state.orderID,
        },
      });
    }

    console.log(data);
    console.log("Value", value);
    console.log("ForData", FormData);
  };
  //   const handleChange = (value) => {
  //     console.log(value);
  //   };
  const adult = location.state.body
    ? location.state.body.AdultCount
    : location.state.returnBody.AdultCount;
  const child = location.state.body
    ? location.state.body.ChildCount
    : location.state.returnBody.ChildCount;
  const infant = location.state.body
    ? location.state.body.InfantCount
    : location.state.returnBody.InfantCount;
  const ar = [];
  const ar2 = [];
  const ar3 = [];
  for (let i = 1; i <= adult; i++) {
    ar.push({});
  }
  for (let i = 1; i <= child; i++) {
    ar2.push({});
  }
  for (let i = 1; i <= infant; i++) {
    ar3.push({});
  }
  console.log("first", ar);

  return (
    <>
      <Formik
        initialValues={{
          adults: ar,
          childs: ar2,
          infants: ar3,
        }}
        onSubmit={handleFormSubmit}
      >
        {(formik) => (
          <Form>
            <Box
              className={classes.root}
              style={{
                background: "white",
                padding: "10px 15px",
                border: "1px solid #e6e6e6",
                marginTop: "10px",
                boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                borderRadius: "5px",
              }}
            >
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginTop: 20, alignItems: "baseline" }}
              >
                <Grid item xs={12} lg={6}>
                  <Field
                    component={TextField}
                    name="email"
                    type="email"
                    variant="outlined"
                    // error={errors.email}
                    label="Email ID"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 12 },
                    }}
                  />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Field
                    component={TextField}
                    name="phone"
                    type="number"
                    variant="outlined"
                    // error={errors.phone}
                    label="Mobile No."
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 12 },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
            <FieldArray
              name="adult"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.adults.map((adult, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Adult.${index + 1}`}</div>

                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={4}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                name={`adult.${index}.title`}
                                type="text"
                                variant="outlined"
                                label="Select Title"
                                // error={errors.titleA1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {title.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={4}>
                              <Field
                                component={TextField}
                                name={`adult.${index}.firstname`}
                                type="text"
                                // error={errors.first_nameA1}
                                variant="outlined"
                                label="Enter First Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={4}>
                              <Field
                                component={TextField}
                                name={`adult.${index}.lastname`}
                                type="text"
                                // error={errors.last_nameA1}
                                variant="outlined"
                                label="Enter Last Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.passportnumber`}
                                    type="text"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.expiry`}
                                    type="date"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Select Expiry Date"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`adult.${index}.dob`}
                                    type="date"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Select DOB"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}

                            {/* </Box> */}
                            {location.state.body&&<>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={12}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <span style={{ width: "100%" }}>
                                  Select Excess Baggage
                                </span>
                                <Field
                                  component={TextField}
                                  select
                                  name={`adult.${index}.baggage`}
                                  type="text"
                                  variant="outlined"
                                  label="Select Baggage"
                                  // error={errors.titleA1}
                                  className={classes.selectField}
                                  InputProps={{
                                    className: classes.InputPropsStyle,
                                  }}
                                  inputProps={{
                                    className: classes.inputPropsStyle,
                                  }}
                                >
                                  {farequotetripjack
                                    ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.BAGGAGE?.map(
                                        (item, inde) => {
                                          return (
                                            <MenuItem
                                              key={inde}
                                              value={item}
                                              onClick={() =>
                                                index === 0
                                                  ? dispatch(
                                                      setBaggageAdult1(item)
                                                    )
                                                  : index === 1
                                                  ? dispatch(
                                                      setBaggageAdult2(item)
                                                    )
                                                  : index === 2
                                                  ? dispatch(
                                                      setBaggageAdult3(item)
                                                    )
                                                  : index === 3
                                                  ? dispatch(
                                                      setBaggageAdult4(item)
                                                    )
                                                  : index === 4
                                                  ? dispatch(
                                                      setBaggageAdult5(item)
                                                    )
                                                  : index === 5
                                                  ? dispatch(
                                                      setBaggageAdult6(item)
                                                    )
                                                  : index === 6
                                                  ? dispatch(
                                                      setBaggageAdult7(item)
                                                    )
                                                  : index === 7
                                                  ? dispatch(
                                                      setBaggageAdult8(item)
                                                    )
                                                  : index === 8
                                                  ? dispatch(
                                                      setBaggageAdult9(item)
                                                    )
                                                  : ""
                                              }
                                            >
                                              {`${item.desc} Rs ${item.amount}`}
                                            </MenuItem>
                                          );
                                        }
                                      )
                                    : ssrTBO &&
                                      ssrTBO?.result &&
                                      ssrTBO?.result.Response.Baggage[0]?.map(
                                        (item, inde) => (
                                          <MenuItem
                                            key={inde}
                                            value={item}
                                            onClick={() =>
                                              index === 0
                                                ? dispatch(
                                                    setBaggageAdult1(item)
                                                  )
                                                : index === 1
                                                ? dispatch(
                                                    setBaggageAdult2(item)
                                                  )
                                                : index === 2
                                                ? dispatch(
                                                    setBaggageAdult3(item)
                                                  )
                                                : index === 3
                                                ? dispatch(
                                                    setBaggageAdult4(item)
                                                  )
                                                : index === 4
                                                ? dispatch(
                                                    setBaggageAdult5(item)
                                                  )
                                                : index === 5
                                                ? dispatch(
                                                    setBaggageAdult6(item)
                                                  )
                                                : index === 6
                                                ? dispatch(
                                                    setBaggageAdult7(item)
                                                  )
                                                : index === 7
                                                ? dispatch(
                                                    setBaggageAdult8(item)
                                                  )
                                                : index === 8
                                                ? dispatch(
                                                    setBaggageAdult9(item)
                                                  )
                                                : ""
                                            }
                                          >
                                            {`${item.Weight}kg ${curr} ${Number(Math.round(Number(item.Price)*Convert))}`}
                                          </MenuItem>
                                        )
                                      )}
                                </Field>
                                {index === 0 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult1?.AirlineCode
                                        ? `Baggage : ${baggageAdult1?.Weight} kg`
                                        : baggageAdult1?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult1?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult1?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult1?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 1 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult2?.AirlineCode
                                        ? `Baggage : ${baggageAdult2?.Weight} kg`
                                        : baggageAdult2?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult2?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult2?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult2?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 2 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult3?.AirlineCode
                                        ? `Baggage : ${baggageAdult3?.Weight} kg`
                                        : baggageAdult3?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult3?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult3?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult3?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 3 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult4?.AirlineCode
                                        ? `Baggage : ${baggageAdult4?.Weight} kg`
                                        : baggageAdult4?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult4?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult4?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult4?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 4 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult5?.AirlineCode
                                        ? `Baggage : ${baggageAdult5?.Weight} kg`
                                        : baggageAdult5?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      Baggage Charges : {curr}
                                      {baggageAdult5?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult5?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult5?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 5 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult6?.AirlineCode
                                        ? `Baggage : ${baggageAdult6?.Weight} kg`
                                        : baggageAdult6?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult6?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult6?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult6?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 6 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult7?.AirlineCode
                                        ? `Baggage : ${baggageAdult7?.Weight} kg`
                                        : baggageAdult7?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult7?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult7?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult7?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 7 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult8?.AirlineCode
                                        ? `Baggage : ${baggageAdult8?.Weight} kg`
                                        : baggageAdult8?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult8?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult8?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult8?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 8 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageAdult9?.AirlineCode
                                        ? `Baggage : ${baggageAdult9?.Weight} kg`
                                        : baggageAdult9?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : {curr}
                                      {baggageAdult9?.AirlineCode
                                        ? Number(Math.round(Number(baggageAdult9?.Price)*Convert))
                                        : Number(Math.round(Number(baggageAdult9?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={12}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <span style={{ width: "100%" }}>
                                  Select Meal Preferences 
                                </span>
                                <Field
                                  component={TextField}
                                  select
                                  name={`adult.${index}.meal`}
                                  type="text"
                                  variant="outlined"
                                  label="Select Meal"
                                  // error={errors.titleA1}
                                  className={classes.selectField}
                                  InputProps={{
                                    className: classes.InputPropsStyle,
                                  }}
                                  inputProps={{
                                    className: classes.inputPropsStyle,
                                  }}
                                >
                                  {farequotetripjack
                                    ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.MEAL?.map(
                                        (item, inde) => {
                                          return (
                                            <MenuItem
                                              key={inde}
                                              value={item}
                                              onClick={() =>
                                                index === 0
                                                  ? dispatch(
                                                      setMealAdult1(item)
                                                    )
                                                  : index === 1
                                                  ? dispatch(
                                                      setMealAdult2(item)
                                                    )
                                                  : index === 2
                                                  ? dispatch(
                                                      setMealAdult3(item)
                                                    )
                                                  : index === 3
                                                  ? dispatch(
                                                      setMealAdult4(item)
                                                    )
                                                  : index === 4
                                                  ? dispatch(
                                                      setMealAdult5(item)
                                                    )
                                                  : index === 5
                                                  ? dispatch(
                                                      setMealAdult6(item)
                                                    )
                                                  : index === 6
                                                  ? dispatch(
                                                      setMealAdult7(item)
                                                    )
                                                  : index === 7
                                                  ? dispatch(
                                                      setMealAdult8(item)
                                                    )
                                                  : index === 8
                                                  ? dispatch(
                                                      setMealAdult9(item)
                                                    )
                                                  : ""
                                              }
                                            >
                                              {`${item.desc} ${curr} ${Number(Math.round(Number(item.amount)*Convert))}`}
                                            </MenuItem>
                                          );
                                        }
                                      )
                                    : ssrTBO &&
                                      ssrTBO?.result &&
                                      ssrTBO?.result.Response.MealDynamic[0]?.map(
                                        (item, inde) => (
                                          <MenuItem
                                            key={inde}
                                            value={item}
                                            onClick={() =>
                                              index === 0
                                                ? dispatch(
                                                    setMealAdult1(item)
                                                  )
                                                : index === 1
                                                ? dispatch(
                                                    setMealAdult2(item)
                                                  )
                                                : index === 2
                                                ? dispatch(
                                                    setMealAdult3(item)
                                                  )
                                                : index === 3
                                                ? dispatch(
                                                    setMealAdult4(item)
                                                  )
                                                : index === 4
                                                ? dispatch(
                                                    setMealAdult5(item)
                                                  )
                                                : index === 5
                                                ? dispatch(
                                                    setMealAdult6(item)
                                                  )
                                                : index === 6
                                                ? dispatch(
                                                    setMealAdult7(item)
                                                  )
                                                : index === 7
                                                ? dispatch(
                                                    setMealAdult8(item)
                                                  )
                                                : index === 8
                                                ? dispatch(
                                                    setMealAdult9(item)
                                                  )
                                                : ""
                                            }
                                          >
                                            {`${item.AirlineDescription}kg ${curr} ${Number(Math.round(Number(item.Price)*Convert))}`}
                                          </MenuItem>
                                        )
                                      )}
                                </Field>
                                {index === 0 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult1?.AirlineCode
                                        ? `Meal : ${mealAdult1?.AirlineDescription} `
                                        : mealAdult1?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult1?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult1?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult1?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 1 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult2?.AirlineCode
                                        ? `Meal : ${mealAdult2?.AirlineDescription}`
                                        : mealAdult2?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult2?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult2?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult2?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 2 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult3?.AirlineCode
                                        ? `Meal : ${mealAdult3?.AirlineDescription} `
                                        : mealAdult3?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult3?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult3?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult3?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 3 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult4?.AirlineCode
                                        ? `Meal : ${mealAdult4?.AirlineDescription} `
                                        : mealAdult4?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult4?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult4?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult4?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 4 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult5?.AirlineCode
                                        ? `Meal : ${mealAdult5?.AirlineDescription} `
                                        : mealAdult5?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult5?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult5?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult5?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 5 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult6?.AirlineCode
                                        ? `Meal : ${mealAdult6?.AirlineDescription}`
                                        : mealAdult6?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult6?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult6?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult6?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 6 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult7?.AirlineCode
                                        ? `Meal : ${mealAdult7?.AirlineDescription} `
                                        : mealAdult7?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult7?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult7?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult7?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 7 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult8?.AirlineCode
                                        ? `Meal : ${mealAdult8?.AirlineDescription}`
                                        : mealAdult8?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult8?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult8?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult8?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : index === 8 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealAdult9?.AirlineCode
                                        ? `Meal : ${mealAdult9?.AirlineDescription}`
                                        : mealAdult9?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : {curr}
                                      {mealAdult9?.AirlineCode
                                        ? Number(Math.round(Number(mealAdult9?.Price)*Convert))
                                        : Number(Math.round(Number(mealAdult9?.amount)*Convert))}
                                    </span>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            </>}
                          </Grid>
                        </Box>
                      </>
                    ))}
                  </div>
                );
              }}
            />
            <FieldArray
              name="child"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.childs.map((child, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Child.${index + 1}`}</div>
                          {/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={3}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                name={`child.${index}.title`}
                                type="text"
                                variant="outlined"
                                label="Select Title"
                                // error={errors.titleC1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {titleC.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.firstname`}
                                type="text"
                                variant="outlined"
                                // error={errors.first_nameC1}
                                label="Enter First Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.lastname`}
                                type="text"
                                variant="outlined"
                                // error={errors.last_nameC1}
                                label="Enter Last Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`child.${index}.dob`}
                                type="date"
                                variant="outlined"
                                // error={errors.last_nameC1}
                                label="Select DOB"
                                className={classes.selectField}
                                // style={{color:'lightgrey'}}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`child.${index}.passportnumber`}
                                    type="text"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`child.${index}.expiry`}
                                    type="date"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Select Expiry Date"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                            {location.state.body&&
                            <>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={12}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <span style={{ width: "100%" }}>
                                  Select Excess Baggage
                                </span>
                                <Field
                                  component={TextField}
                                  select
                                  name={`child.${index}.baggage`}
                                  type="text"
                                  variant="outlined"
                                  label="Select Baggage"
                                  // error={errors.titleA1}
                                  className={classes.selectField}
                                  InputProps={{
                                    className: classes.InputPropsStyle,
                                  }}
                                  inputProps={{
                                    className: classes.inputPropsStyle,
                                  }}
                                >
                                  {farequotetripjack
                                    ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.BAGGAGE?.map(
                                        (item, inde) => {
                                          return (
                                            <MenuItem
                                              key={inde}
                                              value={item}
                                              onClick={() =>
                                                index === 0
                                                  ? dispatch(
                                                      setBaggageChild1(item)
                                                    )
                                                  : index === 1
                                                  ? dispatch(
                                                      setBaggageChild2(item)
                                                    )
                                                  : index === 2
                                                  ? dispatch(
                                                      setBaggageChild3(item)
                                                    )
                                                  : index === 3
                                                  ? dispatch(
                                                      setBaggageChild4(item)
                                                    )
                                                  : index === 4
                                                  ? dispatch(
                                                      setBaggageChild5(item)
                                                    )
                                                  : index === 5
                                                  ? dispatch(
                                                      setBaggageChild6(item)
                                                    )
                                                  : ""
                                              }
                                            >
                                              {`${item.desc} Rs ${item.amount}`}
                                            </MenuItem>
                                          );
                                        }
                                      )
                                    : ssrTBO &&
                                      ssrTBO?.result &&
                                      ssrTBO?.result.Response.Baggage[0]?.map(
                                        (item, inde) => (
                                          <MenuItem
                                            key={inde}
                                            value={item}
                                            onClick={() =>
                                              index === 0
                                                ? dispatch(
                                                    setBaggageChild1(item)
                                                  )
                                                : index === 1
                                                ? dispatch(
                                                    setBaggageChild2(item)
                                                  )
                                                : index === 2
                                                ? dispatch(
                                                    setBaggageChild3(item)
                                                  )
                                                : index === 3
                                                ? dispatch(
                                                    setBaggageChild4(item)
                                                  )
                                                : index === 4
                                                ? dispatch(
                                                    setBaggageChild5(item)
                                                  )
                                                : index === 5
                                                ? dispatch(
                                                    setBaggageChild6(item)
                                                  )
                                                : ""
                                            }
                                          >
                                            {`${item.Weight}kg Rs ${item.Price}`}
                                          </MenuItem>
                                        )
                                      )}
                                </Field>
                                {index === 0 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild1?.AirlineCode
                                        ? `Baggage : ${baggageChild1?.Weight} kg`
                                        : baggageChild1?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild1?.AirlineCode
                                        ? baggageChild1?.Price
                                        : baggageChild1?.amount}
                                    </span>
                                  </Box>
                                ) : index === 1 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild2?.AirlineCode
                                        ? `Baggage : ${baggageChild2?.Weight} kg`
                                        : baggageChild2?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild2?.AirlineCode
                                        ? baggageChild2?.Price
                                        : baggageChild2?.amount}
                                    </span>
                                  </Box>
                                ) : index === 2 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild3?.AirlineCode
                                        ? `Baggage : ${baggageChild3?.Weight} kg`
                                        : baggageChild3?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild3?.AirlineCode
                                        ? baggageChild3?.Price
                                        : baggageChild3?.amount}
                                    </span>
                                  </Box>
                                ) : index === 3 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild4?.AirlineCode
                                        ? `Baggage : ${baggageChild4?.Weight} kg`
                                        : baggageChild4?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild4?.AirlineCode
                                        ? baggageChild4?.Price
                                        : baggageChild4?.amount}
                                    </span>
                                  </Box>
                                ) : index === 4 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild5?.AirlineCode
                                        ? `Baggage : ${baggageChild5?.Weight} kg`
                                        : baggageChild5?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild5?.AirlineCode
                                        ? baggageChild5?.Price
                                        : baggageChild5?.amount}
                                    </span>
                                  </Box>
                                ) : index === 5 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {baggageChild6?.AirlineCode
                                        ? `Baggage : ${baggageChild6?.Weight} kg`
                                        : baggageChild6?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Baggage Charges : Rs.{" "}
                                      {baggageChild6?.AirlineCode
                                        ? baggageChild6?.Price
                                        : baggageChild6?.amount}
                                    </span>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={12}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <span style={{ width: "100%" }}>
                                  Select Meal Preferences
                                </span>
                                <Field
                                  component={TextField}
                                  select
                                  name={`child.${index}.meal`}
                                  type="text"
                                  variant="outlined"
                                  label="Select Meal"
                                  // error={errors.titleA1}
                                  className={classes.selectField}
                                  InputProps={{
                                    className: classes.InputPropsStyle,
                                  }}
                                  inputProps={{
                                    className: classes.inputPropsStyle,
                                  }}
                                >
                                  {farequotetripjack
                                    ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.MEAL?.map(
                                        (item, inde) => {
                                          return (
                                            <MenuItem
                                              key={inde}
                                              value={item}
                                              onClick={() =>
                                                index === 0
                                                  ? dispatch(
                                                      setMealChild1(item)
                                                    )
                                                  : index === 1
                                                  ? dispatch(
                                                      setMealChild2(item)
                                                    )
                                                  : index === 2
                                                  ? dispatch(
                                                      setMealChild3(item)
                                                    )
                                                  : index === 3
                                                  ? dispatch(
                                                      setMealChild4(item)
                                                    )
                                                  : index === 4
                                                  ? dispatch(
                                                      setMealChild5(item)
                                                    )
                                                  : index === 5
                                                  ? dispatch(
                                                      setMealChild6(item)
                                                    )
                                                  : ""
                                              }
                                            >
                                               {`${item.desc} Rs ${item.amount}`}
                                             
                                            </MenuItem>
                                          );
                                        }
                                      )
                                    : ssrTBO &&
                                      ssrTBO?.result &&
                                      ssrTBO?.result.Response.MealDynamic[0]?.map(
                                        (item, inde) => (
                                          <MenuItem
                                            key={inde}
                                            value={item}
                                            onClick={() =>
                                              index === 0
                                                ? dispatch(
                                                    setMealChild1(item)
                                                  )
                                                : index === 1
                                                ? dispatch(
                                                    setMealChild2(item)
                                                  )
                                                : index === 2
                                                ? dispatch(
                                                    setMealChild3(item)
                                                  )
                                                : index === 3
                                                ? dispatch(
                                                    setMealChild4(item)
                                                  )
                                                : index === 4
                                                ? dispatch(
                                                    setMealChild5(item)
                                                  )
                                                : index === 5
                                                ? dispatch(
                                                    setMealChild6(item)
                                                  )
                                                : ""
                                            }
                                          >
                                           {`${item.AirlineDescription}kg Rs ${item.Price}`}
                                          </MenuItem>
                                        )
                                      )}
                                </Field>
                                {index === 0 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild1?.AirlineCode
                                        ? `Meal : ${mealChild1?.AirlineDescription}`
                                        : mealChild1?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild1?.AirlineCode
                                        ? mealChild1?.Price
                                        : mealChild1?.amount}
                                    </span>
                                  </Box>
                                ) : index === 1 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild2?.AirlineCode
                                        ? `Meal : ${mealChild2?.AirlineDescription}`
                                        : mealChild2?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild2?.AirlineCode
                                        ? mealChild2?.Price
                                        : mealChild2?.amount}
                                    </span>
                                  </Box>
                                ) : index === 2 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild3?.AirlineCode
                                        ? `Meal : ${mealChild3?.AirlineDescription}`
                                        : mealChild3?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild3?.AirlineCode
                                        ? mealChild3?.Price
                                        : mealChild3?.amount}
                                    </span>
                                  </Box>
                                ) : index === 3 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild4?.AirlineCode
                                        ? `Meal : ${mealChild4?.AirlineDescription}`
                                        : mealChild4?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild4?.AirlineCode
                                        ? mealChild4?.Price
                                        : mealChild4?.amount}
                                    </span>
                                  </Box>
                                ) : index === 4 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild5?.AirlineCode
                                        ? `Meal : ${mealChild5?.AirlineDescription}`
                                        : mealChild5?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild5?.AirlineCode
                                        ? mealChild5?.Price
                                        : mealChild5?.amount}
                                    </span>
                                  </Box>
                                ) : index === 5 ? (
                                  <Box
                                    style={{ width: "100%", marginLeft: 20 }}
                                  >
                                    <span>
                                      {mealChild6?.AirlineCode
                                        ? `Meal : ${mealChild6?.AirlineDescription}`
                                        : mealChild6?.desc}
                                    </span>
                                    <span>
                                      <br></br>
                                      Meal Charges : Rs.{" "}
                                      {mealChild6?.AirlineCode
                                        ? mealChild6?.Price
                                        : mealChild6?.amount}
                                    </span>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            </>
                            }
                          </Grid>
                        </Box>
                      </>
                    ))}
                  </div>
                );
              }}
            />
            <FieldArray
              name="infant"
              render={(arrayHelpers) => {
                return (
                  <div>
                    {formik.values.infants.map((infant, index) => (
                      <>
                        <Box
                          className={classes.root}
                          style={{
                            background: "white",
                            padding: "10px 15px",
                            border: "1px solid #e6e6e6",
                            marginTop: "10px",
                            boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                            borderRadius: "5px",
                          }}
                        >
                          <div>{`Enter the Detail of Infant.${index + 1}`}</div>
                          {/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            style={{ marginTop: 20, alignItems: "baseline" }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              lg={3}
                              className={classes.root2}
                              style={{ alignItems: "center" }}
                            >
                              <Field
                                component={TextField}
                                select
                                name={`infant.${index}.title`}
                                type="text"
                                variant="outlined"
                                label="Select Title"
                                // error={errors.titleC1}
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  className: classes.inputPropsStyle,
                                }}
                              >
                                {titleI.map((item, index) => (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.firstname`}
                                type="text"
                                variant="outlined"
                                // error={errors.first_nameC1}
                                label="Enter First Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.lastname`}
                                type="text"
                                variant="outlined"
                                // error={errors.last_nameC1}
                                label="Enter Last Name"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <Field
                                component={TextField}
                                name={`infant.${index}.dob`}
                                type="date"
                                variant="outlined"
                                // placeholder="Select DOB"
                                // error={errors.last_nameC1}
                                label="Select DOB"
                                className={classes.selectField}
                                InputProps={{
                                  className: classes.InputPropsStyle,
                                }}
                                inputProps={{
                                  style: { padding: 12 },
                                }}
                              />
                            </Grid>
                            {selectedOrigin.country_code === "IN" &&
                            selectedDepart.country_code === "IN" ? (
                              ""
                            ) : (
                              <>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`infant.${index}.passportnumber`}
                                    type="text"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Enter Passport Number"
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={4}>
                                  <Field
                                    component={TextField}
                                    name={`infant.${index}.expiry`}
                                    type="date"
                                    // error={errors.last_nameA1}
                                    variant="outlined"
                                    label="Select Expiry Date"
                                    // value=''
                                    className={classes.selectField}
                                    InputProps={{
                                      className: classes.InputPropsStyle,
                                    }}
                                    inputProps={{
                                      style: { padding: 12 },
                                    }}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Box>
                      </>
                    ))}
                  </div>
                );
              }}
            />
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ marginBottom: 20 }}
            >
              <Grid item xs={3}></Grid>
              <Grid item xs={12} lg={4}>
                <button
                  type="submit"
                  className={classes.createButton}
                  style={{ marginTop: 10, fontSize: 16, cursor: "pointer" }}
                >
                  Continue
                </button>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default FlightSummaryForm;
